import { render, staticRenderFns } from "./update-competition.vue?vue&type=template&id=2d6e2b90&lang=pug"
import script from "./update-competition.vue?vue&type=script&lang=js"
export * from "./update-competition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports